import { render } from "./menuManage.vue?vue&type=template&id=ef8e5024&scoped=true"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"

import "./menuManage.vue?vue&type=style&index=0&id=ef8e5024&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8e5024"]])

export default __exports__